import { render, staticRenderFns } from "./HotelVoucherCancellation.vue?vue&type=template&id=5f633c46&scoped=true"
import script from "./HotelVoucherCancellation.vue?vue&type=script&lang=js"
export * from "./HotelVoucherCancellation.vue?vue&type=script&lang=js"
import style0 from "./HotelVoucherCancellation.vue?vue&type=style&index=0&id=5f633c46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f633c46",
  null
  
)

export default component.exports